import React from 'react';
import { Icon } from '@fikasio/react-ui-components';
import { SearchResultType } from 'utils/search';

const SEARCH_RESULT_ICONS = {
  OBJECTIVE: 'bullseye',
  PROJECT: 'project-diagram',
  TASK: 'check-square',
} as const;

const SearchResultTypeIcon = ({
  className,
  type,
}: {
  className?: string;
  type: SearchResultType;
}) => (
  <Icon
    className={className}
    name={SEARCH_RESULT_ICONS[type]}
    size="1x"
  />
);

export default SearchResultTypeIcon;
